
interface IHeaderConfiguration {
  name?: string;
  sortName?: string;
  key: string;
  sortingField?: string;
  sortable: boolean;
}

import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { TranslationService } from "@/core/services/TranslationService";
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  toRefs,
} from "vue";

export default defineComponent({
  name: "vz-sort",
  emits: ["update-sort"],
  props: {
    options: {
      type: Array as () => Array<IHeaderConfiguration>,

      required: true,
    },
    dataLength: { type: Number, default: 1 },
    viewName: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const { viewName, options, dataLength } = toRefs(props);
    const currentSort = ref<string>("");
    const getOptions = computed(() => {
      return options.value.map((item) => {
        return { ...item, key: item.sortingField ?? item.key };
      });
    });
    const sortChange = (sort: string) => {
      currentSort.value = sort;
      emit("update-sort", `${sort}`);
    };
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    onMounted(() => {
      nextTick(() => {
        const menuElement = document.querySelector(
          `#vz-sort-data-${viewName.value}`
        ) as HTMLElement;
        if (menuElement && !MenuComponent?.getInstance(menuElement)) {
          MenuComponent.reinitialization();
        }
      });
    });
    return {
      currentSort,
      getOptions,
      t,
      sortChange,
    };
  },
});
